module.exports = __webpack_public_path__ + "static/media/404.9d009bd9.png";